package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.bodyMMedium
import com.arenaproplay.admin.ui.theme.bodyMRegular
import com.arenaproplay.admin.ui.utils.sBorderRadius
import org.jetbrains.compose.web.css.*

/**
 * Court Light empty-state block — icon circle, title, hint text, and an
 * optional action slot (pass any composable, e.g. a Button or a text link).
 */
@Composable
fun EmptyState(
    icon: String,
    title: String,
    hint: String,
    modifier: Modifier = Modifier,
    action: (@Composable () -> Unit)? = null
) {
    Box(
        modifier.fillMaxWidth().padding(topBottom = 56.px),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            // Icon circle
            Box(
                Modifier
                    .width(56.px)
                    .height(56.px)
                    .borderRadius(50.percent)
                    .styleModifier {
                        property("background", "#101828")
                        property("border", "1px solid #1C2634")
                    },
                contentAlignment = Alignment.Center
            ) {
                SpanText(icon, Modifier.fontSize(24.px))
            }

            Box(Modifier.height(16.px))

            SpanText(title, Modifier.bodyMMedium().color(AppColors.Ink))

            Box(Modifier.height(6.px))

            SpanText(
                hint,
                Modifier.bodyMRegular().color(AppColors.Muted)
                    .styleModifier { property("text-align", "center") }
            )

            if (action != null) {
                Box(Modifier.height(20.px))
                action()
            }
        }
    }
}
